import { render } from "./declined.vue?vue&type=template&id=22126b94"
import script from "./declined.vue?vue&type=script&lang=js"
export * from "./declined.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__